import template from './deactivateCustomerAdmin.html';
import controller from './deactivateCustomerAdmin.controller';

let deactivateCustomerAdminComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default deactivateCustomerAdminComponent;



// WEBPACK FOOTER //
// ./app/components/deactivateCustomerAdmin/deactivateCustomerAdmin.component.js